module.exports = __webpack_public_path__ + "static/media/welcome5.b64d83fd.webp";